export default __webpack_public_path__ + "static/media/web.eeedf20a.jpg";